import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[casBannerContent]',
})
export class BannerContentDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
